<template>
  <div>
    <!--Stats cards-->
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-6">
        <stats-card
          :type="siteCount.type"
          :icon="siteCount.icon"
          :small-title="siteCount.title"
          :title="siteCount.value"
        >
          <div class="stats" slot="footer">
            <i :class="siteCount.footerIcon"></i>
            {{ siteCount.footerText }}
          </div>
        </stats-card>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <stats-card
          :type="stationCount.type"
          :icon="stationCount.icon"
          :small-title="stationCount.title"
          :title="stationCount.value"
        >
          <div class="stats" slot="footer">
            <i :class="stationCount.footerIcon"></i>
            {{ stationCount.footerText }}
          </div>
        </stats-card>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <stats-card
          :type="connectionCount.type"
          :icon="connectionCount.icon"
          :small-title="connectionCount.title"
          :title="connectionCount.value"
        >
          <div class="stats" slot="footer">
            <i :class="connectionCount.footerIcon"></i>
            {{ connectionCount.footerText }}
          </div>
        </stats-card>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <stats-card
          :type="bookingCount.type"
          :icon="bookingCount.icon"
          :small-title="bookingCount.title"
          :title="bookingCount.value"
        >
          <div class="stats" slot="footer">
            <i :class="bookingCount.footerIcon"></i>
            {{ bookingCount.footerText }}
          </div>
        </stats-card>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <leaflet-map> </leaflet-map>
      </div>
    </div>
  </div>
</template>
<script>
import StatsCard from "src/components/UIComponents/Cards/StatsCard";
import Loading from "src/components/Dashboard/Layout/LoadingMainPanel.vue";
import LeafletMap from "src/components/Dashboard/Views/Maps/LeafletMap.vue";
import HTTP from "src/util/http-common.js";
import routes from "../../../../routes/routes";

const WorldMap = () => ({
  component: import("./../Maps/WorldMap.vue"),
  loading: Loading,
  delay: 200,
});

export default {
  components: {
    StatsCard,
    WorldMap,
    LeafletMap,
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data() {
    return {
      siteCount: {
        type: "warning",
        icon: "fa fa-globe",
        title: "Sites",
        value: "",
        footerText: "Updated now",
        footerIcon: "nc-icon nc-refresh-69",
      },
      stationCount: {
        type: "success",
        icon: "fas fa-charging-station",
        title: "Stations",
        value: "",
        footerText: "Last day",
        footerIcon: "nc-icon nc-calendar-60",
      },
      connectionCount: {
        type: "danger",
        icon: "fas fa-plug",
        title: "Connections",
        value: "",
        footerText: "In the last hour",
        footerIcon: "nc-icon nc-bell-55",
      },
      bookingCount: {
        type: "info",
        icon: "fas fa-book",
        title: "Bookings",
        value: "",
        footerText: "Updated now",
        footerIcon: "nc-icon nc-refresh-69",
      },
    };
  },
  created() {
    this.initDashboard();
  },
  methods: {
    initDashboard() {
      this.getSiteCount();
      this.getStationCount();
      this.getConnectionCount();
      this.getBookingCount();
    },
    getSiteCount() {
      HTTP.get("api/v1/dashboard/data?stat=site")
        .then((response) => {
          this.siteCount.value = response.data.toString();
        })
        .catch((err) => {
          this.notifyVue(
            "Error retrieving stat for site",
            err.response.data.message,
            "error"
          );
        });
    },
    getStationCount() {
      HTTP.get("api/v1/dashboard/data?stat=station")
        .then((response) => {
          this.stationCount.value = response.data.toString();
        })
        .catch((err) => {
          this.notifyVue(
            "Error retrieving stat for station",
            err.response.data.message,
            "error"
          );
        });
    },
    getConnectionCount() {
      HTTP.get("api/v1/dashboard/data?stat=connection")
        .then((response) => {
          this.connectionCount.value = response.data.toString();
        })
        .catch((err) => {
          console.log(err);
          this.notifyVue(
            "Error retrieving stat for connection",
            err.response.data.message,
            "error"
          );
        });
    },
    getBookingCount() {
      HTTP.get("api/v1/dashboard/data?stat=booking")
        .then((response) => {
          this.bookingCount.value = response.data.toString();
        })
        .catch((err) => {
          console.log(err);
          this.notifyVue(
            "Error retrieving stat for booking",
            err.response.data.message,
            "error"
          );
        });
    },
  },
  mounted() {
    var p = localStorage.getItem("permissions");
    let canshow = p.includes("dashboard.get");
    if (canshow) {
    } else {
      this.$router.push({ path: "/" });
    }
  },
};
</script>
<style scoped>
.spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 60px;
  width: 60px;
  margin: 0px auto;
  -webkit-animation: rotation 0.6s infinite linear;
  -moz-animation: rotation 0.6s infinite linear;
  -o-animation: rotation 0.6s infinite linear;
  animation: rotation 0.6s infinite linear;
  border-left: 6px solid rgba(0, 174, 239, 0.15);
  border-right: 6px solid rgba(0, 174, 239, 0.15);
  border-bottom: 6px solid rgba(0, 174, 239, 0.15);
  border-top: 6px solid rgba(0, 174, 239, 0.8);
  border-radius: 100%;
}

@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
  }
}
@-moz-keyframes rotation {
  from {
    -moz-transform: rotate(0deg);
  }
  to {
    -moz-transform: rotate(359deg);
  }
}
@-o-keyframes rotation {
  from {
    -o-transform: rotate(0deg);
  }
  to {
    -o-transform: rotate(359deg);
  }
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>>

</style>
